export default __webpack_public_path__ + "static/media/customer_led_efficiency.862af841.png";